import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  name: z.string().min(1, { message: msg.required }),
  club: z.tuple([z.string(), z.number()], { message: msg.required }),
  division: z.tuple([z.string(), z.number()], { message: msg.required }),
});

export type Schema = z.infer<typeof schema>;
